import o from "./ghl-ui.es810.js";
import t from "./ghl-ui.es811.js";
import a from "./ghl-ui.es812.js";
import r from "./ghl-ui.es813.js";
import m from "./ghl-ui.es814.js";
var e = {
  code: "nb",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s = e;
export {
  s as default
};
